import { Config } from '@ratehub/base-ui';

import getGICsProductShape from './getGICsProductShape';
import getSharedDepositShape from './getSharedDepositShape';
import fetchDeposit from './fetchDeposit';


const API_ENDPOINT = `${Config.GICS_API_URL}/rate-queue`;

/**
 * Fetch *monetized* GICs according to options.
 * If the requested GIC is not monetized, or qualified based on province and language,
 * a monetized fallback replacement will be provided in its place.
 * @param {string} options.province - Province code
 * @param {string} options.language - Language code
 * @typedef {{
 *      requested: Array<{ id: string }>,
 * @param options
 *      - fallback: { Object },
 * }} ProductQuery
 * @param {Array<ProductQuery>} options.products - An array of requested products ordered by priority
 * @param options.products
 * @returns {Promise<{data: {products: Array<object>}}>}
 */
async function fetchGICs(options) {
    const response = await fetchDeposit(options, API_ENDPOINT);

    return {
        data: {
            products: response.data?.products?.map(getGICProductShape) || [],
        },
    };
}

function getGICProductShape(product) {
    return product
        ? {
            // Get ProductSingle display specific fields
            ...getGICsProductShape(product),

            // Get slots/queue specific fields
            ...getSharedDepositShape(product),

            // Shared fields that overlap between ProductSingle and slots are:
            // provider, isSponsored, detailsURL, and applyURL
        }
        : undefined;
}

export default fetchGICs;
